import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { MaterialService, ProdutoService } from 'almoxarifado-lib';
import {
  BaseResourceFormComponent, EddyAutoComplete, FuncaoService, GlobalService, LoginContabil, Produto, ProdutoLocalizacao
} from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { ProdutoLocalizacaoService } from '../service/produto-localizacao.service';

@Component({
  selector: 'lib-produto-localizacao-form',
  templateUrl: './produto-localizacao-form.component.html'
})
export class ProdutoLocalizacaoFormComponent extends BaseResourceFormComponent<ProdutoLocalizacao, LoginContabil> {

  /**
   * Declaração de variáveis
   */

  public produtoAutoComplete: EddyAutoComplete<Produto>;

  @ViewChild('sala_') inputField: ElementRef;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private messageService: MessageService,
    protected funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected materialService: MaterialService,
    protected produtoService: ProdutoService,
    protected produtoLocalizacaoService: ProdutoLocalizacaoService
  ) {
    super(new ProdutoLocalizacao(), injector, ProdutoLocalizacao.converteJson, produtoLocalizacaoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      sala: [null, [Validators.required]],
      armario: [null, [Validators.required]],
      prateleira: [null, [Validators.required]],
      produto: [null]
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'produto' };
  }

  protected afterLoad() {
    this.produtoAutoComplete.id = this.entidade.produto ? this.entidade.produto.id : null;
  }

  protected afterInit(): void {
    this.carregarAutoCompletes();
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  protected beforeSubmit() { }

  protected afterSubmit(modelo: ProdutoLocalizacao) { }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================
  private carregarAutoCompletes() {
    this.produtoAutoComplete = new EddyAutoComplete(null, this.produtoService,
      'id', ['codigo', 'nome'], { orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }
    );
  }
}
